import { render, staticRenderFns } from "./Item9.vue?vue&type=template&id=0a30aefc&scoped=true&"
import script from "./Item9.vue?vue&type=script&lang=js&"
export * from "./Item9.vue?vue&type=script&lang=js&"
import style0 from "./Item9.vue?vue&type=style&index=0&id=0a30aefc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a30aefc",
  null
  
)

export default component.exports